import { UnicodeEntity } from '@mews/enums';
import { isDefined } from '@mews/std';

interface formatExchangeRateLabelProps {
    fromCurrency?: { currencyCode: string; value: number } | null;
    toCurrency?: { currencyCode: string; value: number } | null;
}

export const formatExchangeRateLabel = ({ toCurrency, fromCurrency }: formatExchangeRateLabelProps): string => {
    if (toCurrency === null || !isDefined(toCurrency)) {
        return '';
    }

    if (fromCurrency === null || !isDefined(fromCurrency)) {
        return '';
    }

    return `${fromCurrency.value}${UnicodeEntity.NoBreakSpace}${fromCurrency.currencyCode}${UnicodeEntity.NoBreakSpace}${UnicodeEntity.Equals}${UnicodeEntity.NoBreakSpace}${toCurrency.value}${UnicodeEntity.NoBreakSpace}${toCurrency.currencyCode}`;
};
